/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { MongoUser } from '@core/models/mongo';
import { AccountActions } from '@settings/store/actions';
import { UsersActions } from '@store/actions';
export const ACCOUNT_FEATURE_KEY = 'account';

export interface AccountState {
  user: MongoUser;
  isLoading: boolean;
  isUploading: boolean;
}

const initialState: AccountState = {
  user: null,
  isLoading: false,
  isUploading: false,
} as any;
export const accountReducer = createReducer(
  initialState,
  on(AccountActions.loadUser, (state) => ({ ...state, isLoading: true })),
  on(AccountActions.loadUserSuccess, (state, { user }) => ({ ...state, user: { ...user }, isLoading: false })),
  on(AccountActions.loadUserFailure, (state) => ({ ...state, isLoading: false })),
  on(AccountActions.updateUser, AccountActions.updatePassword, (state) => ({ ...state, isLoading: true })),
  on(AccountActions.updateUserSuccess, AccountActions.updatePasswordSuccess, (state, { user }) => ({
    ...state,
    user: { ...user },
    isLoading: false,
  })),
  on(UsersActions.updateUserSuccess, (state, { user }) => ({
    ...state,
    user: user.email === state.user?.email ? user : state.user,
  })),
  on(AccountActions.updateUserFailure, AccountActions.updatePasswordFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(AccountActions.updateUserProfilePicture, (state) => ({ ...state, isUploading: true })),
  on(AccountActions.updateUserProfilePictureSuccess, (state, { url_s, user }) => ({
    ...state,
    user: { ...state.user, ...user, profileImage: { ...state.user.profileImage, url_s } },
    isUploading: false,
  })),
  on(AccountActions.updateUserProfilePictureFailure, (state) => ({ ...state, isUploading: false })),
  on(AccountActions.removeProfilePictureWhenUserNotUpdated, (state, { url_s, user }) => ({
    ...state,
    user: { ...state.user, ...user, profileImage: { ...state.user.profileImage, url_s } },
  }))
);
